export const moduleType = {
  RECOMMENDATION: 'KundenWerbenKunden',
  TEAMBUILDING: 'Teamaufbau',
};
